import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from 'components/App/App';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import * as serviceWorker from './serviceWorker';
import firebase from 'firebase/app';
import 'firebase/analytics';
import { FIREBASE_CONFIG } from 'constants/config';
import { init, ErrorBoundary } from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import ErrorFallback from './components/UI/ErrorFallback';

// Initialize Firebase
firebase.initializeApp(FIREBASE_CONFIG);
firebase.analytics();

if (process.env.REACT_APP_SENTRY) {
  init({ dsn: process.env.REACT_APP_SENTRY, integrations: [new Integrations.BrowserTracing()], tracesSampleRate: 1.0 });
}

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary fallback={ErrorFallback}>
      <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
          <App />
        </QueryParamProvider>
      </Router>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
